export default __webpack_public_path__ + "static/pipeline-413ec69e5c1d9707e05a7df048b82029.png";